import CategoriesApp from './CategoriesApp.vue';
import { createPageApp } from '@/createPageApp';

const app = createPageApp();

// Registrem el component principal de la pàgina
app.component('categories-app', CategoriesApp);

app.mount('#vue-categories-app');
